module.exports = __webpack_public_path__ + "img/Weapon_225.60e19c00.png";